import * as Yup from 'yup';
import {  LIT_REQUIRED } from '../../../constant/message';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required(LIT_REQUIRED),
});
